import { render, staticRenderFns } from "./SelectableTaxonomies.vue?vue&type=template&id=6146e8ec&"
import script from "./SelectableTaxonomies.vue?vue&type=script&lang=ts&"
export * from "./SelectableTaxonomies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports